const providers = new Map<string, string>([
  ['s3', 'https://debossgarage.s3.amazonaws.com/'],
  ['imgkit', 'https://ik.imagekit.io/ikdeboss/'],
  ['api', `${process.env.NEXT_PUBLIC_BACKEND_URL}/api/img/`],
])

// Set the default provider
let defaultStorageURL = providers.get('s3')

/**
 * Remove the prefix from the storage URL
 *
 * @param url The url to be prefixed
 */
const removeProviderPrefixes = (url: string): string => {
  let newURL = url

  // Remove any prefixes that are present
  for (const [, value] of providers) {
    newURL = newURL.replace(value, '')
  }

  return newURL
}

/**
 * Get the prefixed storage URL for an image
 *
 * @param url
 * @param provider
 */
export const getPrefixedStorageURL = (
  url?: string,
  provider?: 's3' | 'imgkit' | 'api'
): string => {
  if (!url) return ''

  // Clean off any provider prefixes that are present
  const cleanURL = removeProviderPrefixes(url)

  // If a provider is provided, use it
  if (provider) {
    return `${providers.get(provider)}${cleanURL}`
  }

  // If a provider is not provided, use the default
  return `${defaultStorageURL}${cleanURL}`
}
